// extracted by mini-css-extract-plugin
module.exports = {"pendingContainer":"PendingLimits__pendingContainer--wx_","error":"PendingLimits__error--3qq"};